//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AlertComponent from 'app_components/commons/alert'
import GraphcardCommon from 'app_components/commons/graphcard'
import SatisfactionSummarySkeleton from './satisfactionSummarySkeleton'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../satisfactionSummaryModule.scss'

// @ADD Component types
interface ISatisfactionSummaryModuleLayoutProps {
  currentYear: number,
  label: string,
  reportData: any
  chartOptions: any
  status: 'loading' | 'error' | null
}

const SatisfactionSummaryModuleLayout: React.FC<ISatisfactionSummaryModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='satisfaction_summary_module-component'>
      <div className="title-graph">
        {`${t(`modules.satisfaction_summary_module.title`)} ${props.label} ${props.currentYear}`}
      </div>
      <div className="graph">
        {props.status === 'loading' ? (
          <SatisfactionSummarySkeleton />
        ) : (
          <>
            {props.reportData ? (
              <GraphcardCommon
                type='bars'
                data={props.reportData}
                options={props.chartOptions}
              />
            ): (
              <AlertComponent
                type='warning'
                title={t('modules.satisfaction_summary_module.no_data')}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default SatisfactionSummaryModuleLayout
